/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

const termsOfServiceStyle = {
  termsOfServicePage: (theme: Theme) => ({
    margin: "2rem 0",
    [theme.breakpoints.up("md")]: {
      margin: "5rem 0",
    },
  }),
  headline: {
    hyphens: "auto",
  },
  indented: {
    paddingLeft: "2.5rem",
  },
};

export default termsOfServiceStyle;
